var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createFormFromSelector } from "../utils.js";
export function getAdvancesGroupByMembers(ctx_1, companyId_1) {
    return __awaiter(this, arguments, void 0, function* (ctx, companyId, params = {}) {
        const form = createFormFromSelector(params);
        const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "/query/advances/employees"), {
            method: "POST",
            body: form.toString(),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
        return (yield res.json());
    });
}
export function getPayments(ctx_1, companyId_1) {
    return __awaiter(this, arguments, void 0, function* (ctx, companyId, params = {}) {
        const form = createFormFromSelector(params);
        const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId, "/query/repayments"), {
            method: "POST",
            body: form.toString(),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
        return (yield res.json());
    });
}
export function getOrganizationStatus(ctx, companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organizations/", companyId), {
            method: "GET",
        });
        return (yield res.json());
    });
}
export function registerOrganization(ctx, companyId, payload) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const res = yield ctx.client.fetch(ctx.baseUrl.joinPath("/v1/manage/organization/initialize"), {
            method: "POST",
            body: JSON.stringify({
                iid: companyId,
                isDefaultCoveringRepaymentCosts: (_a = payload.isDefaultCoveringRepaymentCosts) !== null && _a !== void 0 ? _a : null,
                termSchedule: payload.termSchedule,
                joinedAt: payload.joinedAt,
            }),
            headers: {
                "Content-Type": "application/json",
            },
        });
    });
}
